import { getApiBase, getHttpClient } from "../utils/api";

export const savedFilterScopes = [
  "deals",
  "spot_contract_deals",
  "adjustment_deals",
  "payments",
  "spot_contract_payments",
] as const;

export type SavedFilterScope = (typeof savedFilterScopes)[number];

export type SavedFilter = {
  id: number;
  scope: SavedFilterScope;
  name: string;
  filters: Record<string, unknown>;
  created_at: string;
  updated_at: string;
};

type SavedFilterCreate = Pick<SavedFilter, "scope" | "name" | "filters">;

export const getSavedFilters = async (scope: SavedFilterScope): Promise<SavedFilter[]> => {
  const response = await getHttpClient()(`${getApiBase()}/saved_filters?scope=${encodeURIComponent(scope)}`);
  return response.json;
};

export const createSavedFilter = async (savedFilter: SavedFilterCreate): Promise<SavedFilter> => {
  const response = await getHttpClient()(`${getApiBase()}/saved_filters`, {
    method: "POST",
    body: JSON.stringify(savedFilter),
  });
  return response.json;
};

export const renameSavedFilter = async (id: number, name: string): Promise<SavedFilter> => {
  const response = await getHttpClient()(`${getApiBase()}/saved_filters/${id}`, {
    method: "PUT",
    body: JSON.stringify({ name }),
  });
  return response.json;
};

export const deleteSavedFilter = async (id: number): Promise<void> => {
  await getHttpClient()(`${getApiBase()}/saved_filters/${id}`, { method: "DELETE" });
};
